import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a5cf14e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { ref, watch } from 'vue'
import { AddressStatus } from '@/interfaces/admin/places'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubpremisePrompt',
  props: {
  addressStatus: {
    type: String as () => AddressStatus | null,
    default: null
  },
  currentLine2: {
    type: String,
    default: ''
  }
},
  emits: ['update-subpremise'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const subpremiseInput = ref(props.currentLine2)

watch(() => props.currentLine2, (newValue) => {
  subpremiseInput.value = newValue
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "expand" }, {
    default: _withCtx(() => [
      (__props.addressStatus === _unref(AddressStatus).ADD_SUBPREMISE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('addressState.subpremiseMessage')), 1)
          ]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}
}

})